import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Calendly = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="10" fill="hsl(from hsl(217 100% 50%) h s 50%)" />
    <path
      d="M16 8.5C15 7.2 13.5 6.5 12 6.5C9 6.5 6.5 9 6.5 12C6.5 15 9 17.5 12 17.5C13.5 17.5 15 16.8 16 15.5"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);
